module.exports = __webpack_public_path__ + "img/logo.e080df63.png";